<template>
  <el-col
    v-if="canAction('shipping_bids_edit')"
    id="day-prices"
    style="padding-left: 20px; padding-right: 12px; margin-bottom: 8px"
    :span="24"
  >
    <el-row :gutter="24" type="flex" align="middle" style="margin-bottom: 8px">
      <p class="route_tble__dayInfo mr-p">Цена погрузка:</p>
      <template v-if="day.type_code !== 'harvest'">
        <p class="blue mr-p">
          <b>
            {{ day.price_from_storage_bidder | getPrice }}
          </b>
        </p>
        <p
          v-if="isAdminOrCeoRole"
          :class="day.price_from_storage_driver ? 'green mr-p' : 'red mr-p'"
        >
          <b>
            {{ day.price_from_storage_driver | getPrice }}
          </b>
        </p>
      </template>
    </el-row>
    <el-row :gutter="24" type="flex" align="middle" style="margin-bottom: 8px">
      <p class="route_tble__dayInfo mr-p">Цена уборка:</p>
      <template v-if="day.type_code !== 'delivery'">
        <p class="blue mr-p">
          <b>
            {{ day.price_from_field_bidder | getPrice }}
          </b>
        </p>
        <p
          v-if="isAdminOrCeoRole"
          :class="day.price_from_storage_driver ? 'green mr-p' : 'red mr-p'"
        >
          <b>
            {{ day.price_from_field_driver | getPrice }}
          </b>
        </p>
      </template>
    </el-row>
  </el-col>
</template>

<script>
export default {
  name: 'DayPrices',
  props: {
    day: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="sass">
#day-prices
  .mr-p
    margin-right: 5px
    margin-left: 5px
  p
    text-align: center
    margin: 0
    line-height: 20px
    font-size: 14px
    color: #3D3D3D
    &.green
      color: #589839
    &.blue
      color: #3498DB
    &.red
      color: #ff0000
</style>
